import "Styles/templates/page.colter-footwear.scss";
import Images360 from '../components/360-images';
import ProductSlider from '../vue/product-slider/index';
import StickyBar from '../components/sticky-bar';

import Swiper from 'swiper';
import SwiperCore, { Controller, EffectFade, A11y } from 'swiper/core';
SwiperCore.use([Controller, EffectFade, A11y]);

Images360();
ProductSlider();
StickyBar();

var galleryTop = new Swiper('.testimonials__wrapper', {
  slidesPerView: 1,
  spaceBetween: 16,
  slideClass: 'swiper__col', 
  wrapperClass: 'swiper__row',
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  a11y: {
    enabled: true
  }
});

var galleryThumbs = new Swiper('.testimonials__thumbs-wrapper', {
  slidesPerView: 8,
  spaceBetween: 16,
  slideClass: 'swiper__col', 
  wrapperClass: 'swiper__row',
  breakpoints: {
    // when window width is >= 768
    1024: {
      slidesPerView: 4.2,
      spaceBetween: 16
    }
  },
  a11y: {
    enabled: true
  }
});

galleryTop.controller.control = galleryThumbs;
galleryThumbs.controller.control = galleryTop;